import React from 'react';
import RepliesStates from '../types/replies_states';

const ShowMoreRepliesButton = ({ rowlength, count, state, incrementCallback, subthread }) => {
  let classList = '';
  if (subthread) {
    classList = classList.concat(' subthread');
  }

  return (
    rowlength > count && state !== RepliesStates.HIDDEN
      ? <a className={classList} onClick={() => incrementCallback()}>Show more replies</a>
      : null
  );
};

export default ShowMoreRepliesButton;
